import { type PropsWithChildren } from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useIntl } from 'react-intl';
import { useRiskClassificationScale } from './RiskClassificationScaleContext';
import FullPageLoadingIndicator from 'components/v2/FullPageLoadingIndicator';

export default function RiskClassificationScaleBoundary({ children }: PropsWithChildren) {
   const intl = useIntl();
   const { error, isLoading, refresh } = useRiskClassificationScale();

   if (isLoading) return <FullPageLoadingIndicator />;
   if (!error) return children;

   return (
      <Box sx={{ mx: 'auto', maxWidth: 720, p: 3 }}>
         <Alert
            severity="error"
            action={
               <Button color="inherit" onClick={() => void refresh()}>
                  {intl.formatMessage({ id: 'supplyChain.riskClassificationScale.retry', defaultMessage: 'Try again' })}
               </Button>
            }
         >
            {intl.formatMessage({
               id: 'supplyChain.riskClassificationScale.loadError',
               defaultMessage: 'The classification scale could not be loaded. Select Try again to retry.',
            })}
         </Alert>
      </Box>
   );
}
